<template>
  <div class="c-table" ref="iOSTable">
    <!-- <Spin size="large" fix v-if="loading"></Spin> -->
    <el-table class="common-el-table-styles" ref="table" :data="data" :height="height" v-loading="loading" border stripe>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'state'">
            <Poptip confirm transfer :title="popTitleTxt(scope.row.status)" @on-ok="switchPlan(scope.row)">
              <i class="cover-mask"></i>
              <i-Switch :value="scope.row.status" size="small" :true-value="1" :false-value="0" />
            </Poptip>
          </div>
          <div v-else-if="col.key === 'ruleInfo'">
            <span class="block-span g-error-text">{{ scope.row['dataRange'] | rangeType }}{{ scope.row['monitorType'] | satisType }}</span>
            <span class="block-span" v-for="(cond, i) in scope.row[col.key]" :key="i">{{ cond | conditions }}</span>
          </div>
          <div v-else-if="col.key === 'control'">
            <Poptip confirm transfer placement="top-end" title="您确认删除该iOS监控规则吗？" @on-ok="$emit('on-del', scope.row)">
              <el-button type="text" size="small">删除</el-button>
            </Poptip>
            <el-button type="text" size="small" @click="copyClick(scope.row)">&ensp;复制</el-button>
            <el-button type="text" size="small" @click="editClick(scope.row)">&ensp;修改</el-button>
          </div>
          <div v-else-if="col.key === 'alertType'">
            <span class="block-span g-error-text">{{ scope.row[col.key] | alertType }}</span>
            <span class="block-span">{{ scope.row['monitorTime'] | timeType }}</span>
          </div>
          <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'lastRpTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { timeout } from '@/common/js/utils'

import { switchiOSMonitor } from '@/api/manage.model'
import filteriOSes from '../../data/filters_ios'
export default {
  name: 'iOSTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    type: {
      type: String
    },
    height: {
      type: Number
    }
  },
  methods: {
    popTitleTxt(state) {
      const txt = state ? '关闭' : '开启'
      return `确定要${txt}此iOS监控规则吗？`
    },
    switchPlan(row) {
      const { ruleId, status } = row
      const changStat = status ? 0 : 1
      switchiOSMonitor({ ruleId, status: changStat }).then((data) => {
        if (data) {
          this.$set(row, 'status', changStat)
          this.$emit('on-refresh')
        }
      })
    },
    editClick(row) {
      const { ruleId } = row
      this.$router.push({ name: 'iosmonitoradd', query: { id: ruleId, t: 'edit' } })
    },
    copyClick(row) {
      const { ruleId } = row
      this.$router.push({ name: 'iosmonitoradd', query: { id: ruleId } })
    }
  },
  filters: {
    alertType(val) {
      let type
      switch (val) {
        case 1:
          type = '仅钉钉'
          break
        case 2:
          type = '仅邮件'
          break
        case 3:
          type = '邮件+钉钉'
          break
        default:
          type = '未启用'
          break
      }
      return type
    },
    timeType(monitorTime) {
      let timeTxt = ''
      if (monitorTime && monitorTime.key === 'quarter') timeTxt = '每15分钟'
      else if (monitorTime && monitorTime.key === 'half') timeTxt = '每半小时'
      else if (monitorTime && monitorTime.key === 'day') timeTxt = `每天 ${monitorTime.value}`
      return timeTxt
    },
    rangeType(val) {
      let type
      switch (val) {
        case 1:
          type = '今日实时；'
          break
        default:
          type = '未知数据；'
          break
      }
      return type
    },
    satisType(val) {
      if (val === 'all') return '全部条件'
      else return '任意条件'
    },
    conditions(cell) {
      let condTxt = ''
      if (cell && cell.key) {
        const cond = filteriOSes.filter((met) => met.key === cell.key).pop()
        if (cond) condTxt = `${cond.name}${cell.expression}${cell.value}${cond.unit}`
      }
      return condTxt
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  .block-span {
    display: block;
  }

  .ivu-poptip {
    position: relative;

    .cover-mask {
      display: inline-block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      z-index: 3;
      cursor: pointer;
    }
  }
}
</style>
